export const VISUAL_DESIGNER_SUPPLIER_KIND = 'visual_designer_supplier_transmission';

export type SupplierTransmissionChannel = 'email_format' | 'email_attachment';

export type SupplierTransmissionMeta = {
  kind: typeof VISUAL_DESIGNER_SUPPLIER_KIND;
  project_id: string;
  projectId: string;
  visual_survey_id: string | null;
  visual_survey_label: string | null;
  document_id: string | null;
  document_version_id: string | null;
  document_version_number: number | null;
  supplier_id: string | null;
  supplier_name: string | null;
  channel: SupplierTransmissionChannel;
  item_count: number | null;
};

export function buildSupplierTransmissionMetadata(input: {
  projectId: string;
  surveyId?: string | null;
  surveyLabel?: string | null;
  documentId?: string | null;
  documentVersionId?: string | null;
  documentVersionNumber?: number | null;
  supplierId?: string | null;
  supplierName?: string | null;
  channel: SupplierTransmissionChannel;
  itemCount?: number;
}): SupplierTransmissionMeta {
  return {
    kind: VISUAL_DESIGNER_SUPPLIER_KIND,
    project_id: input.projectId,
    projectId: input.projectId,
    visual_survey_id: input.surveyId || null,
    visual_survey_label: input.surveyLabel || null,
    document_id: input.documentId || null,
    document_version_id: input.documentVersionId || null,
    document_version_number: Number.isFinite(Number(input.documentVersionNumber))
      ? Math.trunc(Number(input.documentVersionNumber))
      : null,
    supplier_id: input.supplierId || null,
    supplier_name: input.supplierName || null,
    channel: input.channel,
    item_count: Number.isFinite(Number(input.itemCount)) ? Math.trunc(Number(input.itemCount)) : null,
  };
}
